






























import { defineComponent, computed } from '@nuxtjs/composition-api';
import { TypeDisplay, TypeBody, TypeOverline } from '@bambeehr/pollen';

export default defineComponent({
  name: 'ValueBlade',
  components: {
    TypeDisplay,
    TypeBody,
    TypeOverline,
  },
  props: {
    background: {
      type: String,
    },
    decorator: {
      type: String,
    },
    title: {
      type: String,
    },
    body: {
      type: String,
    },
  },
  setup(props) {
    const backgroundColor = computed(() => {
      switch (props.background) {
        case 'grey':
          return 'bg-grayBackgroundWeak';
        case 'purple':
          return 'bg-primary';
        default:
          return '';
      }
    });
    const titleColor = computed(() => {
      switch (props.background) {
        case 'grey':
          return 'text-black';
        case 'purple':
          return 'text-white';
        default:
          return 'text-primary';
      }
    });
    const bodyColor = computed(() => {
      switch (props.background) {
        case 'purple':
          return 'text-white';
        default:
          return 'text-grayBody';
      }
    });

    return {
      backgroundColor,
      titleColor,
      bodyColor,
    };
  },
});
